import { Component, inject, OnInit, OnDestroy, Optional } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { MatBottomSheet, MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { ActionsBottomSheetComponent } from "app/layout/common/actions-bottom-sheet/actions-bottom-sheet.component";
import { BillingStateService } from "app/core/store/billing/billing.state.service";
import { DialogRef } from "@angular/cdk/dialog";
import { GlobalService } from "app/global.service";
import { ReclamationDialogComponent } from "../reclamation-dialog/reclamation-dialog.component";
import { SuccesSnakBarComponent } from "../succes-snak-bar/succes-snak-bar.component";
import { ErrordialogComponent } from "../errordialog/errordialog.component";
import { filter, take } from "rxjs";
import { PopupDialogQueueService } from "app/popup-dialog-queue.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UserStateService } from "app/core/store/user/user.state.service";
import { NotificationStateService } from "app/core/store/notification/notification.state.service";
import { 
  NotificationSettingsDialogComponent,
} from "app/layout/components/notification-settings-dialog/notification-settings-dialog.component";
import { SchedulingSettingComponent } from "app/main/pop-ups/scheduling-setting/scheduling-setting.component";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";
import { LayoutService } from "app/layout/layout.service";
import moment from "moment";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatDialog } from "@angular/material/dialog";
import { ShareActionService } from "app/core/services/share-action.service";
import { PermissionConfig } from "app/core/permission/permissions.config";
import { DirectivesModule } from "app/shared/directives/directives.module";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { AuthentificationService } from "app/main/authentification/authentification.service";
import { environment } from "environments/environment";
import { Platform } from "@angular/cdk/platform";
import { SmallNavigationService } from "app/core/services/small-navigation-sevice.service";
import { TranslocoModule, TranslocoService } from "@ngneat/transloco";

@Component({
  selector: "app-settings-page",
  imports: [
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatBottomSheetModule,
    CommonModule,
    MatProgressSpinnerModule,
    DirectivesModule,
    TranslocoModule,
  ],
  standalone: true,
  templateUrl: "./settings-page.component.html",
  styleUrl: "./settings-page.component.scss",

})
export class SettingsPageComponent implements OnInit, OnDestroy {

  get settingsRowArrowIcon(): string {
    return this._transloco.getActiveLang() === 'ar' ? 'chevron_left' : 'chevron_right';
  }

  get settingsBackArrowIcon(): string {
    return 'arrow_back';
  }

  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  private _smallNavigationService = inject(SmallNavigationService);
  
  private _bottomSheet = inject(MatBottomSheet);

  public _router = inject(Router);

  public billingState = inject(BillingStateService);

  public _shareActionService = inject(ShareActionService);

  public dialogRef = inject(DialogRef<SettingsPageComponent>, { optional: true });

  public _authentificationService = inject(AuthentificationService);

  private _globalService = inject(GlobalService);

  private _popupDialogService = inject(PopupDialogQueueService);

  private snackBar = inject(MatSnackBar);

  public _userState = inject(UserStateService);

  public _notificationState = inject(NotificationStateService);

  private _fuseSidebarService = inject(FuseSidebarService);

  private layoutService = inject(LayoutService);

  private dialog = inject(MatDialog);

  private _platform = inject(Platform);
  private _transloco = inject(TranslocoService);
  
  administrationPermissions = PermissionConfig.administration;

  settingsPermissions = PermissionConfig.settings;


  calendarPermissions = PermissionConfig.calendar;

  onlineServicePermissions = PermissionConfig["online-service"];

  public settingsItems = {
    "schoolItems": {
      title: "settings.school",
      items: [
        { icon: "tarif_icon",
          textKey: "settings.tariff",
          route: "/administration/agence",
          action: "route",
          params: { tab: "tarif" },
          accessTypes: ['full_access',],
          permissions: this.administrationPermissions["view-tarif"],
        },
        { icon: "work_time_icon",
          textKey: "settings.schedule",
          route: "/administration/agence",
          action: "route",
          params: { tab: "horaire" },
          accessTypes: ['full_access'],
          permissions: this.administrationPermissions["view-horaire"],
        },
        { icon: "work_suit",
          textKey: "settings.general",
          route: "/administration/agence",
          action: "route",
          accessTypes: ['full_access'],
          params: { tab: "agence" },
          permissions: this.administrationPermissions["view-agency"],
        },
        { icon: "travel_explore",
          textKey: "settings.onlineServices",
          route: "/online-services/list",
          action: "route",
          params: "online-service",
          accessTypes: ['full_access', 'code_only'],
          permissions: this.onlineServicePermissions["view-online-service"],
        },
        { icon: "redeem",
          textKey: "settings.referral", 
          route: "/referral",
          action: "route",
          params: "referral",
          accessTypes: ['full_access', 'code_only'],


        },
      ],
    },
    "ParameterItems": {
      title: "settings.parameters",
      items: [
        /*{ icon: "flag",
          textKey: "settings.country",
          subtitleKey: "countrySettings.subtitle",
          route: "/settings/country",
          action: "route",
          params: "country",
          accessTypes: ['full_access', 'code_only'],
        },*/
        ...(environment.showTranslationButton ? [
          { icon: "translate",
            textKey: "settings.language",
            route: "/settings/language",
            action: "route",
            params: "language",
            accessTypes: ['full_access', 'code_only'],
          },
        ] : []),
        { icon: "payments",
          textKey: "settings.billing",
          route: "/administration/contract",
          action: "route",
          params: "billing",
          accessTypes: ['full_access', 'code_only'],
          permissions: this.administrationPermissions["view-facturation"],
        },
        { icon: "notification_settings_icon",
          textKey: "settings.notifications",
          action: "dialog",
          params: "notif-settings",
          accessTypes: ['full_access', 'code_only'],
          callback: (): void => {
            this.openNotificationPreferenceDialog();
          },

        },
        { icon: "calendar_edit_icon",
          textKey: "settings.calendar",
          action: "dialog",
          params: "calendar-settings",
          accessTypes: ['full_access'],
          callback: (): void => {
            this.openScheduleSettingDialog();
          },
          permissions: this.administrationPermissions["access-event"],

        },
        { icon: "tune",
          textKey: "settings.calculationPreference",
          route: "/administration/agence",
          action: "route",
          params: { tab: "preferences" },
          accessTypes: ['full_access'],
          permissions: this.administrationPermissions["view-preferenceCalcul"],
        },
        {
          icon: "security_defense_icon",
          textKey: "settings.accessSecurity",
          route: "/access-control",
          action: "route",
          params: "access-control",
          accessTypes: ['full_access'],
          permissions: this.settingsPermissions["access-control"],
        }
      ],
    },
    "HelpItems": {
      title: "settingsExtra.help",
      items: [
        { icon: "info",
          text: "Démo",
          textKey: "settingsExtra.demo",
          action: "route",
          params: "demo",
          accessTypes: ['full_access', 'code_only'],
          route: "/help/knowledge/general-info",
        },
        { icon: "client_service_icon",
          text: "Contactez-nous",
          textKey: "settingsExtra.contactUs",
          route: "/administration/contract",
          action: "dialog",
          params: "reclamation",
          accessTypes: ['full_access', 'code_only'],
          callback: (): void => {
            this.openReclamationDialog();
          },

        },
      ],
    },
  };

  public webPageSharingItems = [
    { icon:"facebook_filled_icon", 
      text:"facebook", 
      displayInTopBar: true, 
      callback:"shareWithFacebook", 
      params: "web-page" 
    },
    { icon:"whatsapp_filled_icon", 
      text:"whatsapp", 
      displayInTopBar: true, 
      callback:"shareWithWhatsApp", 
      params: "web-page" 
    }, 
    { icon:"scan_qr_code", 
      text:"QR Code", 
      displayInTopBar: true, 
      callback:"shareQR", 
      params: "web-page" 
    }, 
    { icon:"sms", 
      text:"SMS", 
      displayInTopBar: true, 
      callback:"sharewithSMS", 
      params: "web-page" 
    },
    { icon:"content_copy", 
      textKey:"share.copyLink", 
      callback:"copyLink", 
      params: "web-page" 
    },
    { icon:"arrow_forward", 
      textKey:"share.visitPage", 
      callback: "viewPage",
    },
    { icon:"arrow_forward", 
      textKey:"share.visitWebService", 
      route:"/online-services/list" 
    },
  ];

  public InvitationItems = [
    { icon:"whatsapp_filled_icon",
      text:"whatsapp", 
      displayInTopBar: true, 
      callback:"shareWithWhatsApp", 
      params: "referal"
    }, 
    { icon:"sms", text:"SMS", displayInTopBar: true, callback:"sharewithSMS", params: "referal" },
    { icon:"content_copy", textKey:"share.copyLink", callback:"copyLink", params: "referal" },
  ];

  environment = environment;


  upgrade: boolean = false;

  loadingItems: Set<string> = new Set();

  webpageurl: string = "";

  qrCodeImageUrl: string = "";

  accessType: string = "";

  currentHost = typeof window !== "undefined" ? window.location.hostname : "localhost";

  webPageRequestMade : boolean = false;

  constructor() {
    this.settingsItems.schoolItems.title = 'settings.school';
    this.settingsItems.ParameterItems.title = 'settings.parameters';
    this.settingsItems.schoolItems.items.forEach((item: any) => item.textKey = {
      tarif_icon: 'settings.tariff', work_time_icon: 'settings.schedule', work_suit: 'settings.general',
      travel_explore: 'settings.onlineServices', redeem: 'settings.referral'
    }[item.icon]);
    this.settingsItems.ParameterItems.items.forEach((item: any) => item.textKey = {
      flag: 'settings.country', translate: 'settings.language', payments: 'settings.billing', notification_settings_icon: 'settings.notifications',
      calendar_edit_icon: 'settings.calendar', tune: 'settings.calculationPreference', security_defense_icon: 'settings.accessSecurity'
    }[item.icon]);
    this._globalService.currentUser.subscribe({
      next:(user)=>{
        this.accessType = user.sub_type;
        if (user.sub_type !== "full_access" 
          && moment(user.max_end) > moment() 
          && (user.last_subscription_invoice_status === "paid") 
          && user.finalized_at) {
          this.upgrade = true;
        } else this.upgrade = false;
      },
    });
  }

  ngOnInit(): void {
    // Set up history popstate listener
    if (this._platform.ANDROID || this._platform.IOS) {
      const messengerItem = 
        { 
          icon:"messenger_filled_icon",
          text:"messenger", 
          displayInTopBar: true, 
          callback:"shareWithMessenger", 
          params: "referal" 
        };
      this.InvitationItems.unshift(messengerItem);

    }
  }

  ngOnDestroy(): void {
    // Clean up event listener
  }

  goBack(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this._smallNavigationService.goBack();
    }
  }

  handleNavigationOrDialog(item: any): void {
    // If any loading is in progress, don't allow new actions
    if (this.loadingItems.size > 0) {
      return;
    }
    
    this.loadingItems.add(item?.params);
    switch (item.action) {
      case "route":
        if (typeof item.params === "object") {
          this.navigateTo(item.route, item.params).finally(() => {
            this.loadingItems.delete(item?.params);
            // if (this.dialogRef) {
            //   this.dialogRef.close();
            // }
          });
        } else {
          this.navigateTo(item.route).finally(() => {
            this.loadingItems.delete(item?.params);
            // if (this.dialogRef) {
            //   this.dialogRef.close();
            // } 
          });
        }
        break;
      case "dialog":
        item.callback();
        this.loadingItems.delete(item?.params);
        break;
      default:
        this.loadingItems.delete(item.text);
    }
  }

  navigateTo(route: string, params?: any): Promise<boolean> {
    return this._router.navigate([route], { queryParams: params }).finally(() => {
      // if (this.dialogRef) {
      //   this.dialogRef.close();
      // }
    });
  }

  openBottomSheet(options: any[] = null, displayTopBar?: boolean): void {
    const bottomSheetRef = this._bottomSheet.open(ActionsBottomSheetComponent, {
      data: {
        type: "actions",
        actions: options,
        displayTopBar: !!displayTopBar,
      titleKey: 'share.title',
      },
    });

    bottomSheetRef.afterDismissed().subscribe((result) => {
      if (result?.close) {
        // if (this.dialogRef) {
        //   this.dialogRef.close();
        // }
      }
    });
  }


  openReclamationDialog(): void {
    this._globalService.currentUser.pipe(take(1)).subscribe({
      next:(user)=>{
        this._popupDialogService.openDialog(ReclamationDialogComponent, {
          panelClass: ["common-dialog-style"],
          data: {
            agencyId: user.agenceId,
            isGeneral: true,
          },
        },
        response => {
          if (response === "success") {
            const snackBarRef = this.snackBar.openFromComponent(SuccesSnakBarComponent, {
              duration: 3000,
            });
            snackBarRef.instance.confirmMessage = this._transloco.translate('cashout.messageSent');
          } else if (response === "error") {
            this._popupDialogService.unshiftDialog(ErrordialogComponent, {
              panelClass: ["basic-dialog-style"],
              data: {
                confirmMessage: this._transloco.translate('settingsMessages.contactError'),
              },
            });
          }
        });
      },
    });
  }

  openNotificationPreferenceDialog(): void {
    this._popupDialogService.openDialog(NotificationSettingsDialogComponent, {
      panelClass: ["notification-settings-style", "common-dialog-style"],
      data: null,
    }, () => {
    });
  }

  openScheduleSettingDialog():void {
    this._popupDialogService.openDialog(SchedulingSettingComponent, {
      panelClass: ["common-dialog-style", "sc-setting-d-style"],
    }, () => {
    });
  }

  toggleSidebarOpen(key): void {
    if (!this._fuseSidebarService.getSidebar(key).opened) {
      this.layoutService.MarkQuestionsAsReaded().subscribe(() => {
      });
    }
    this._fuseSidebarService.getSidebar(key).toggleOpen();
    // susbscribe to toggleOpene quickPanel for close if from the intern of the panel 
    this.layoutService.quickPanelToggleOpen.pipe(take(1)).subscribe((res) => {
      if (res[0]) {
        this._fuseSidebarService.getSidebar(key).close();
      }
    });
    // if (this.dialogRef) {
    //   this.dialogRef.close();
    // }
  }

  logout(): void {
    const dialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      panelClass: ["basic-dialog-style"],
      data:{
        confirmer:true,
        warning: true,
        confirmMessage: this._transloco.translate('settingsMessages.logoutConfirm')
      },
    });
    
    dialogRef.afterClosed().subscribe((e:boolean) => {
      if(e) {
        // if (this.dialogRef) {
        //   this.dialogRef.close();
        // }
        this._authentificationService.logOut();
      }
    });
  }
}
